export const endpoints = {
    getAvatarDefault: "avatar/default",
    resolveByChannel: "avatar/resolve-by-channel",
    getAvatarSettings: "avatar-settings/avatar-settings",
    getAvatarTheme: "avatar-themes",
    getPlaylistSettings: "avatar-settings/playlist-settings"
}